export default __webpack_public_path__ + "static/media/gallery-wip-paint_00.fda4aff3.jpg";